import { useEffect, useState } from 'react';

/** Widths at or below this render the mobile shell (top bar plus navigation drawer). */
export const MOBILE_BREAKPOINT = 760;

const readIsMobile = () =>
  typeof window !== 'undefined' ? window.innerWidth <= MOBILE_BREAKPOINT : false;

/** Shared by the Forge, Eval, and Archon layouts so all three shells switch at the same width. */
export function useIsMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(readIsMobile);

  useEffect(() => {
    const handleResize = () => setIsMobile(readIsMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}
